import store from '@/store';

export default {
  mounted() {
    this.fetchPage();
  },
  data() {
    return {
      selected: '',
    };
  },
  computed: {
    wordboards() {
      return store.state.wordboard.wordboards;
    },
    count() {
      return store.state.wordboard.count;
    },
  },
  methods: {
    fetchPage() {
      store.dispatch('wordboard/getWords', {
        filter: {
          limit: this.pageSize,
          skip: (this.selectedPage - 1) * this.pageSize,
        },
      });
    },
    addWord() {
      this.$emit('insert', this.selected);
      this.selected = '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wordboard/wordboard.js